module.exports = "/public/images/e42633a987d111b5493ed2af28f2e381.svg";